import React, { useEffect, useState } from "react";

export default function HeadlineComponent() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    fetch(
      "http://newsapi.org/v2/top-headlines?sources=techcrunch&apiKey=a50d1d9893a642e7a16321f47225c82c"
    )
      .then((res) => res.json())
      .then((data) => {
        setNews(data.articles);
        console.log(data.articles);
      })
      .catch((e) => console.log(e));
  }, [setNews]);
  return (
    <div className='font-custom'>
      <div class='row row-cols-1 row-cols-md-2 g-4'>
        {news.map((news) => (
          <div class='col'>
            <div class='card'>
              <img src={news.urlToImage} class='card-img-top' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>{news.title}</h5>
                <hr />
                <p class='card-text'>
                  {news.description.substring(0, 150) + "..."}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
